import Modal from 'component/hoc/modal/Modal';
import React, { useRef } from 'react';
import styles from './NewGroupModal.module.scss';
import { usePost } from 'hooks/usePost';
import { useFetch } from 'hooks/useFetch';
import { groupEndpoints } from 'hooks/endpoints';
import GroupForm from './group-form/GroupForm';

const NewGroupModal = ({
  isOpen,
  onClose,
  setRefetch,
  refetch,
  id,
  setSelectedGroup,
}) => {
  const { mutate: AddGroup, isPending: isAdding } = usePost();
  const { mutate: EditGroup, isPending: isUpdating } = usePost();
  const formRef = useRef();

  const { data: data, isFetching: isFetching } = useFetch(
    ['userGroupById', id],
    groupEndpoints?.getUserGroupById(id),
    {
      enabled: id != null,
    },
    {
      id: id,
    }
  );

  return (
    <Modal
      title={id === null ? 'New Group' : 'Update Group'}
      isOpen={isOpen}
      onClose={onClose}
      classname={styles['modal-container']}
      modalContent={{
        component: (
          <GroupForm
            AddGroup={AddGroup}
            formRef={formRef}
            onClose={onClose}
            setRefetch={setRefetch}
            refetch={refetch}
            id={id}
            setSelectedGroup={setSelectedGroup}
            data={data?.data}
            isFetching={isFetching}
            EditGroup={EditGroup}
          />
        ),
      }}
      onSubmit={() => formRef.current?.handleSubmit()}
      footerComponent={<></>}
      isLoading={isAdding || isUpdating}
    />
  );
};

export default NewGroupModal;
